import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import { Header, Footer } from "./components"
import { ThemeProvider } from "@material-ui/core/styles"
import theme from "../../theme"
import { CssBaseline } from "@material-ui/core"

const Layout = ({ children, style }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header siteTitle={data.site.siteMetadata.title} />
      <main style={{ marginTop: 48, ...style }}>{children}</main>
      <Footer />
    </ThemeProvider>
  )
}

export default Layout
